import { useNavigate } from 'react-router';
import iconLogo from "url:../../assets/icons/logo-img.svg"
import {Lock} from "flowbite-react-icons/solid";
import {useAuth0} from "@auth0/auth0-react";
import {CONFIG} from "../../constants"

interface Props {
  admin: boolean;
  clientName: string;
  customerName: string;
}

export default function TopHeader(props: Props) {
  const navigate = useNavigate();
  const {
    logout,
  } = useAuth0();

  const doLogout = () => {
    logout({
      logoutParams: {
        clientId: CONFIG.AUTH0_CLIENT_ID,
        returnTo: CONFIG.APP_HOST
      }
    }).then();
  }

  const p = window.location.pathname;

  const links = [
    {name: "Start", path: "/"},
    {name: "Signals", path: "/signals"},
    {name: "KPI", path: "/kpi"},
    {name: "Insights", path: "/insights"},
  ]

  if (props.admin) {
    links.push({name: "Admin: categories", path: "/categories"})
  }

  return (
      <div className="z-top">
        <div className="flex items-end gap-x-8">
          <img src={iconLogo} alt="logo" className="h-6"/>
          {
            links.map((link, i) => {
              let cls = "header_link";
              if (link.path === p) {
                cls += " selected";
              }
              return (
                <div key={"link_" + i} className={cls} onClick={() => navigate(link.path)}>
                  {link.name}
                </div>
              )
            })
          }
        </div>
        <div className="flex items-center">
          <p className="z-title3 text-neutral-100!">{props.clientName} @ {props.customerName}</p>
          <div className="z-button ml-4" onClick={() => doLogout()}>
            <Lock className="h-4 w-4 fill-gray-100"/>
            <p className="ml-2 text-neutral-100">Log out</p>
          </div>
        </div>
      </div>
  );
}